<template>
  <v-container>
    <v-layout row class="buffer">
      <v-flex xs12>
        <h2>Request permissions</h2>
      </v-flex>
    </v-layout>
    <v-layout row class="buffer">
      <v-flex xs12 md6 offset-md3>
        <help-modal/>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 md10 offset-md1>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">Specify permissions</v-stepper-step>
            <v-divider/>
            <v-stepper-step :complete="step > 2" step="2">Select approver/s</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <token-manager v-model="scopes" :servicePermissions="allPermissions"
                             :options="options"/>
              <v-btn @click="goBack">Cancel</v-btn>
              <v-btn @click="gotoStepTwo" class="confirm" :loading="loadingApprovers"
                     :disabled="loadingApprovers">
                Next
              </v-btn>
            </v-stepper-content>
            <v-stepper-content step="2">
              <select-approvers-step v-model="selectedApprovers"
                                     :eligible-approvers="eligibleApprovers"/>
              <v-btn @click="goBack">Cancel</v-btn>
              <v-btn @click="step = 1" class="confirm">Back</v-btn>
              <v-btn @click="submit" color="success">Submit request</v-btn>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-progress-circular indeterminate/>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import TokenManager from '@/views/shared/jwtservices/TokenManager';
  import HelpModal from './HelpModal';
  import SelectApproversStep from './SelectApproversStep';

  export default {
    components: { TokenManager, HelpModal, SelectApproversStep },
    data() {
      return {
        step: 1,
        loadingApprovers: false,
        scopes: {},
        eligibleApprovers: {},
        selectedApprovers: [],
        options: ['request']
      };
    },
    computed: {
      allPermissions() {
        return this.servicePermissions.map((p) => p.code);
      },
      ...mapState('permissions', [
        'servicePermissions'
      ])
    },
    methods: {
      goBack() {
        if (window.history.length > 1) {
          this.$router.go(-1);
        } else {
          this.$router.push('/approvals');
        }
      },
      gotoStepTwo() {
        this.loadingApprovers = true;
        this.$services.authenticator.post('/approvals/approvers', this.scopes)
          .then((response) => {
            this.eligibleApprovers = response.data.data;
            this.loadingApprovers = false;
            this.step = 2;
          }).catch((err) => {
            this.loadingApprovers = false;
            this.$getHandler({
              snackbarProps: {
                timeout: 5000,
                bugReport: false
              }
            })(err);
          });
      },
      submit() {
        this.step = 3;
        this.$services.authenticator.post('/approvals/requests', {
          scopes: this.scopes,
          approvers: this.selectedApprovers.map((aoid) => {
            return { aoid };
          })
        }).then((response) => {
          this.show('Approval request submitted');
          this.$router.push(`/approvals/requests/${response.data.data}`);
        }).catch((e) => {
          this.step = 2;
          return this.$defaultHandlerHttp(e);
        });
      },
      ...mapActions('permissions', [
        'initialize'
      ]),
      ...mapActions('alert', [
        'show'
      ])
    },
    mounted() {
      this.initialize();
    }
  };
</script>

<style lang="less" scoped>
  @import "../../../style/variables.less";

  .buffer {
    margin-bottom: 30px;
  }

  .progress-circular {
    color: @edval-green;
  }
</style>
